import { getUserToken } from "api/utility/localStorageFunctions";
import axios from "axios";
import {
  getMockBookingStatusJobResponse,
  isBookingStatusMockModeEnabled,
} from "Pages/Client/BookingStatusPage/mockBookingStatusData";

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/bookings-api/jobs`;

async function getJobById(id: any) {
  if (!id) {
    return;
  }

  if (isBookingStatusMockModeEnabled()) {
    const mockResponse = getMockBookingStatusJobResponse(id);
    if (mockResponse) {
      return mockResponse;
    }
  }

  const token = await getUserToken("bookings");

  const response = await axios({
    method: "GET",
    url: BASE_URL.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log("jobsAPI getJobById response", response);
  return response;
}

async function reallocateBooking(id: any, data: any) {
  const token = await getUserToken("bookings");

  const response = await axios({
    method: "POST",
    url: BASE_URL.concat(`/${id}/reallocate`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data,
    },
  });
  return response;
}

export const jobsAPI = {
  getJobById,
  reallocateBooking,
};
